const React = require('react')
const { useEffect, useRef } = React
const { Viewer } = require('@toast-ui/react-editor')

const { dom } = require('../odo/odojs/')
const marked = require('marked')
const { mark } = require('regenerator-runtime')
// const htmltovdom = require('html-to-vdom')
// const convert = htmltovdom({
//   VNode: require('virtual-dom/vnode/vnode'),
//   VText: require('virtual-dom/vnode/vtext')
// })

// const renderer = {
//   link(href, title, text)  {
//     console.log(this)
//     console.log(marked)
//     const localLink = href.startsWith(`${location.protocol}//${location.hostname}`)
//     const html = text //this.link.call(renderer, href, title, text)
//     return localLink ? html : html.replace(/^<a /, `<a target="_blank" rel="noreferrer noopener nofollow" `)
//   }
// }

// marked.use({ renderer })

marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  smartLists: true,
  smartypants: false
})

module.exports = markdown => {
  if (markdown == null || markdown.trim() == '') return ''
  // return <Viewer
  //   initialValue={markdown}
  //   customHTMLSanitizer={html => html}
  //   customHTMLRenderer={markdown => {
  //     console.log(markdown)
  //   }}
  //   height="900px"
  // />
  const html = marked.marked(markdown.split('\\n').join(`\n`)) || ''
  const blank_links = html.replace(/<a /, `<a target="_blank" rel="noreferrer noopener nofollow" `)
  return dom('div', { dangerouslySetInnerHTML: { __html: blank_links } })
}
